module.exports = {
    path: '/coredata',
    meta: { module: 'cd' },
    component: () => import('@cd/App'),
    children: [
        {
            path: '',
            name: 'cd-events',
            display: 'Events',
            component: () => import('@cd/views/Events')
        },
        {
            path: 'events',
            name: 'cd-raw-events',
            display: 'Raw Events',
            component: () => import('@cd/views/EventList')
        },
        {
            path: 'errors',
            name: 'cd-errors',
            component: () => import('@cd/views/EventList')
        },
        {
            path: 'customers',
            name: 'cd-customers',
            display: 'Assets',
            component: () => import('@cd/views/Customers')
        },
        {
            path: 'customers/:customerId',
            name: 'cd-assets',
            component: () => import('@cd/views/Assets')
        },
        {
            path: 'customers/:customerId/eventLogExports',
            name: 'eventLogExports',
            component: () => import('@cd/views/EventLogExports')
        },
        {
            path: 'uploads',
            name: 'cd-uploads',
            display: 'Uploads',
            component: () => import('@cd/views/Uploads')
        },
        {
            path: 'exports',
            name: 'cd-exports',
            display: 'Exports',
            component: () => import('@cd/views/Exports')
        },
        {
            path: 'users',
            name: 'cd-users',
            display: 'Users',
            component: () => import('@cd/views/Users')
        },
        {
            path: 'attributes',
            name: 'cd-attributes',
            display: 'Attributes',
            component: () => import('@cd/views/Attributes')
        },
        {
            path: 'rawupload',
            name: 'raw-upload',
            display: 'Raw Files',
            component: () => import('@cd/views/RawUploads')
        },
        {
            path: 'cohorts',
            name: 'cohorts',
            display: 'Cohorts',
            component: () => import('@cd/views/Cohorts')
        },
        {
            path: 'configs',
            name: 'configs',
            display: 'Configurations',
            redirect: {name: 'damageModeConfig'},
            component: () => import('@cd/views/Configs'),
            children: [
                {
                    path: 'damageModeConfig',
                    name: 'damageModeConfig',
                    component: () => import('@cd/views/Configs')
                },
                {
                    path: 'majorComponentConfig',
                    name: 'majorComponentConfig',
                    component: () => import('@cd/views/Configs')
                },
                {
                    path: 'subComponentConfig',
                    name: 'subComponentConfig',
                    component: () => import('@cd/views/Configs')
                }
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/coredata/router.js